module.exports = __webpack_public_path__ + "static/media/icon_menu.b94867c3.svg";